export default class ContactsController {
    constructor($state, $stateParams, $ionicScrollDelegate) {
        this.$state = $state;
        this.contactType = $stateParams.defaultTab;
        this.callingPage = $stateParams.callingPage;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
    }

    init() {
        this.showSortOrderCmb = true;

        this.isFilterActive = () => {
            return (
                this.filterIndicationText &&
                this.filterIndicationText.length > 0
            );
        };

        this.sortOrder = {
            value: 'AUM_DESC',
            field: 'AUM',
            order: 'DESC',
            type: 'AUM',
        };

        this.sortCriteria = [
            {
                value: 'ACCOUNT_ASC',
                field: 'ACCOUNT_NAME',
                order: 'ASC',
                type: 'ACCOUNT',
            },
            {
                value: 'ACCOUNT_DESC',
                field: 'ACCOUNT_NAME',
                order: 'DESC',
                type: 'ACCOUNT',
            },
            { value: 'AUM_DESC', field: 'AUM', order: 'DESC', type: 'AUM' },
            { value: 'AUM_ASC', field: 'AUM', order: 'ASC', type: 'AUM' },
            {
                value: 'LAST_NAME_ASC',
                field: 'LAST_NAME',
                order: 'ASC',
                type: 'NAME',
            },
            {
                value: 'LAST_NAME_DESC',
                field: 'LAST_NAME',
                order: 'DESC',
                type: 'NAME',
            },
            { value: 'TITLE_ASC', field: 'TITLE', order: 'ASC', type: 'TITLE' },
            {
                value: 'TITLE_DESC',
                field: 'TITLE',
                order: 'DESC',
                type: 'TITLE',
            },
        ];

        this.onAssignContactsClick = (e) => {
            // prevent disappering of button from campaign-detail page
            // to avoid the dropdow options from poping up
            this.showSortOrderCmb = false;
            if (this.callingPage !== 'campaignDetail')
                this.showCheckboxes = !this.showCheckboxes;
            this.assignContacts();
        };

        this.updateDisable = (flag) => {
            this.disabled = flag;
        };
    }

    onTabChange(type) {
        this.contactType = type;
        this.$ionicScrollDelegate.scrollTop();
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/contacts/contacts.controller.js
 **/